import styles from "./LanguagesAndUseCases.module.css";
import {
    FaPhoneAlt,
    FaBroadcastTower,
    FaPaperPlane,
    FaHeadphones
} from "react-icons/fa";

const LanguagesAndUseCases = () => {
    return (
        <section className={styles.wrapper}>
            <div className={styles.container}>

                {/* Languages Section */}
                <div className={styles.languagesSection}>
                    <span className={styles.badge}>Native Indic Support</span>

                    <h2>12 Languages, Native Scripts</h2>
                    <p className={styles.subtitle}>
                        Seamless code-mixing between English and Indic languages—all in their
                        native scripts for accurate pronunciation and natural flow.
                    </p>

                    <div className={styles.languageCard}>
                        <div className={styles.tabs}>
                            {[
                                "Hindi", "Tamil", "Telugu", "Kannada", "Malayalam", "Bengali",
                                "Gujarati", "Marathi", "Punjabi", "Odia", "Assamese", "English"
                            ].map((lang, i) => (
                                <button
                                    key={lang}
                                    className={`${styles.tab} ${i === 0 ? styles.active : ""}`}
                                >
                                    {lang}
                                </button>
                            ))}
                        </div>

                        <div className={styles.scriptBlock}>
                            <h4>हिंदी <span>(Hindi)</span></h4>
                            <div className={styles.textBox}>
                                आपका payment अभी तक नहीं आया है।
                            </div>
                        </div>

                        <div className={styles.example}>
                            Example: “मैं message भेज रहा हूँ, but reply नहीं आया,
                            इसलिए I thought दोबारा try करूं”
                            <br />
                            Tamil • English • Telugu • Hindi • Kannada — all native scripts
                        </div>
                    </div>
                </div>

                {/* Use Cases */}
                <div className={styles.useCases}>
                    <h3>Built for Real-World Use</h3>
                    <p className={styles.subtitle}>
                        From voice agents to content creation—our TTS engine powers diverse
                        applications across industries.
                    </p>

                    <div className={styles.grid}>
                        <div className={styles.useCard}>
                            <span className={styles.icon}><FaPhoneAlt /></span>
                            <h4>Voice AI Agents</h4>
                            <p>
                                Power conversational AI with human-like speech that customers
                                can’t distinguish from real agents.
                            </p>
                            <ul>
                                <li>Natural conversations</li>
                                <li>Emotional intelligence</li>
                                <li>Real-time streaming</li>
                            </ul>
                        </div>

                        <div className={styles.useCard}>
                            <span className={styles.icon}><FaBroadcastTower /></span>
                            <h4>IVR Systems</h4>
                            <p>
                                Replace robotic IVR with dynamic, natural-sounding voice prompts
                                that improve caller experience.
                            </p>
                            <ul>
                                <li>Dynamic generation</li>
                                <li>Multi-language support</li>
                                <li>Brand consistency</li>
                            </ul>
                        </div>

                        <div className={styles.useCard}>
                            <span className={styles.icon}><FaPaperPlane /></span>
                            <h4>Outbound Campaigns</h4>
                            <p>
                                Scale voice outreach for sales, collections, and reminders with
                                personalized, empathetic messaging.
                            </p>
                            <ul>
                                <li>Millions of calls/day</li>
                                <li>Personalized content</li>
                                <li>Tone matching</li>
                            </ul>
                        </div>

                        <div className={styles.useCard}>
                            <span className={styles.icon}><FaHeadphones /></span>
                            <h4>Content & Accessibility</h4>
                            <p>
                                Generate voiceovers for videos, e-learning, audiobooks, and
                                accessibility applications.
                            </p>
                            <ul>
                                <li>Studio-quality output</li>
                                <li>Multiple voice options</li>
                                <li>Cost-effective production</li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default LanguagesAndUseCases;
